import { Chip } from "$components/chip";
import { chipColors } from "./constants";

interface Props {
  numerator: number;
  denominator: number;
}

const FractionChip: FC<Props> = ({ numerator, denominator }) => {
  let color = chipColors.positive;
  if (numerator < denominator) {
    color = chipColors.negative;
  }

  return <Chip label={`${numerator} / ${denominator}`} color={color} />;
};

export default FractionChip;
